import React from 'react';
import './DashboardBanner.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Paper from "@material-ui/core/Paper";
import * as moment from 'moment';
import {toggleAccountPreferencesModal} from "../../../redux/reducers/utils";
import {compose} from "redux";
import {connect} from "react-redux";

function DashboardBanner(props) {

  if (!props.user || props.user.subscriptionStatus === 'ACTIVE') {
    return null;
  }

  const getBannerContent = () => {
    switch (props.user.subscriptionStatus) {
      case 'CANCELED':
        return 'Your subscription has been cancelled.';
      case 'EXPIRED':
        return 'Your subscription has expired.';
      case 'FREE_TRIAL_ENDED':
        return 'Your free trial has ended.';
      case 'FREE_TRIAL_ENDS_SOON':
        return 'Your free trial ends soon.';
    }
  };

  return (
    <div className="mb-6 dashboard-banner">
      <Paper className="banner-container">
        <div className="flex items-center banner-warning-content">
          <FontAwesomeIcon icon={'exclamation-circle'} className={`text-alert mr-5`} size="2x"/>
          <div className="flex-1">
            <b className="text-lg">{ getBannerContent() }</b>
            <p className="text-lg mt-2"> <a className="text-secondary" onClick={()=>props.toggleAccountPreferencesModal(true)}>Upgrade your account</a> to keep your existing vaults, or they will be automatically archived on <span className="text-alert font-bold">{moment(props.user.vaultArchiveDate).format("LL")}</span>.</p>
          </div>
        </div>

      </Paper>
    </div>
  );
}

export default compose(
  connect(
    null,
    { toggleAccountPreferencesModal }
  )
)(DashboardBanner);